import { ClosedLocalDateRange6599xgap66zd as ClosedLocalDateRange } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/types.mjs';
import { DatePeriod2y4m7pf19ebgd as DatePeriod } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/DateTimePeriod.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  plus1oi9f9vif99u2 as plus,
  minushnjyym3nfk5o as minus,
} from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDate.mjs';
import {
  CardSemantic_getInstancelcny5le8pbc4 as CardSemantic_getInstance,
  HeaderSemantic_getInstance20a9id3sf7d4x as HeaderSemantic_getInstance,
  get_H2Semantic1i9pxrezr3hyb as get_H2Semantic,
  SubtextSemantic_getInstance1duu1ll1kgx8d as SubtextSemantic_getInstance,
  CompactSemantic_getInstance3lxnpjuev524m as CompactSemantic_getInstance,
  ButtonSemantic_getInstance3q30xblp6a1af as ButtonSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  themed2vu67ornd4jps as themed,
  get_bold3d63kt1t4c9r5 as get_bold,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  Companion_getInstance2uuaiykt2g0g3 as Companion_getInstance,
  BilledDayTotals2enuwcjtkow7 as BilledDayTotals,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/money.mjs';
import {
  plus310ted5e4i90h as plus_0,
  toSet2orjxp16sotqu as toSet,
  filterNotNull3qfgcwmxhwfxe as filterNotNull,
  toList3jhuyej2anx2q as toList,
  chunked1umgsyuj0x9u1 as chunked,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  IDknm0szoty74n as ID,
  ID1z61wlmtvxrjn as ID_0,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/domain.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { keyValue1ck7xpd7fxylw as keyValue } from '../components/view-utilities.mjs';
import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { get_stringsy7vodl9dj0ya as get_strings } from '../../strings.mjs';
import {
  Cents__toString_impl_ko5hxm1a9pwstsznn43 as Cents__toString_impl_ko5hxm,
  Companion_instance1c40ds0jrup2e as Companion_instance,
  Cents1lsbs5l1tlgw as Cents,
  Cents__plus_impl_qsv4s83hvgnvnlu2892 as Cents__plus_impl_qsv4s8,
} from '../../../../../../service-abstractions-currency/com/lightningkite/services/data/Cents.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
} from '../../App.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  _Constant___init__impl__v45mub2qfk15kh5l39c as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import {
  get_rem2p56fiaxda5jo as get_rem,
  get_rem14pbkv8p42gid as get_rem_0,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  Fixedsogarmaf088q as Fixed,
  TableColumn199vk8dy8jaqx as TableColumn,
  tableWithSticky1958em9ua7p76 as tableWithSticky,
} from '../components/table.mjs';
import {
  listOfvhqybd2zx248 as listOf,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { get_entries3dia5qzc4pxls as get_entries } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/attendance.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KtMap140uvy3s5zad8 as KtMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { listOf1jh22dvmctj1r as listOf_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { get_isoDayNumberrycq4er3aoh9 as get_isoDayNumber } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/DayOfWeek.mjs';
import {
  sizeConstraints19w9rda6g3rqz as sizeConstraints,
  get_scrolling3fwkltztkpfe8 as get_scrolling,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  h2ld0l0a2c9zpb as h2,
  subtext2yjmf1ok7kb40 as subtext,
  text189ciz0cnr32o as text,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull } from '../../sdk/currentSession.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { Align_Center_getInstance366ihr7rj12mu as Align_Center_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  Companion_instance3avuh2je008a9 as Companion_instance_0,
  AttendanceEntryBox2fe5zhsdvgxaf as AttendanceEntryBox,
} from '../components/attendanceStyling.mjs';
import { Frame1e7t2kcdb3wu7 as Frame } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Frame.commonHtml.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { weight31wqab1913ly4 as weight } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { onClick3gjrd4jjo1cak as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { dialog3sxbjr735jrum as dialog } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/popoverHelpers.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { await1uwe8zvsjq69o as await_0 } from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { get_pageNavigatorp3to6r4j8ctv as get_pageNavigator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { ChildPlacementDetailPagewfmc55i6s15v as ChildPlacementDetailPage } from '../children/ChildPlacementDetailPage.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_range(_this__u8e3s4) {
  return new (ClosedLocalDateRange())(_this__u8e3s4.get_firstDay_u4rr11_k$(), _this__u8e3s4.get_lastDay_hikhp_k$());
}
function monthStarting(start) {
  return new (ClosedLocalDateRange())(start, minus(plus(start, DatePeriod().new_kotlinx_datetime_DatePeriod_19p8ip_k$(VOID, 1)), DatePeriod().new_kotlinx_datetime_DatePeriod_19p8ip_k$(VOID, VOID, 1)));
}
function remittanceSummary(_this__u8e3s4, days) {
  // Inline function 'com.lightningkite.kiteui.views.card' call
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  var this_0 = themed(_this__u8e3s4, CardSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_0.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(true);
  var totals = Companion_getInstance().of_tann9x_k$(days);
  var payers = plus_0(totals.employers_1.get_values_ksazhn_k$(), totals.grants_1.get_values_ksazhn_k$());
  var tmp = remittanceSummary$lambda;
  keyValue(element, tmp, ($this$keyValue) => {
    // Inline function 'kotlin.collections.map' call
    var this_0 = days;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var item = _iterator__ex2g4s.next_20eer_k$();
      var tmp$ret$7 = new (ID())(item.placement_1);
      destination.add_utx5q5_k$(tmp$ret$7);
    }
    return toSet(destination).get_size_woubt6_k$().toString();
  });
  var tmp_0 = remittanceSummary$lambda_0;
  keyValue(element, tmp_0, ($this$keyValue) => totals.days_1.toString());
  var tmp_1 = remittanceSummary$lambda_1;
  keyValue(element, tmp_1, ($this$keyValue) => $this$keyValue.invoke_r7m7el_k$(get_strings(AppState_getInstance())).remittanceAbsencesValue_hrzn9f_k$(totals.explainedAbsences_1, totals.unexplainedAbsences_1));
  var tmp_2 = remittanceSummary$lambda_2;
  keyValue(element, tmp_2, ($this$keyValue) => Cents__toString_impl_ko5hxm(totals.price_1));
  var tmp_3 = remittanceSummary$lambda_3;
  keyValue(element, tmp_3, ($this$keyValue) => {
    var tmp0 = totals.employers_1.get_values_ksazhn_k$();
    // Inline function 'kotlin.collections.fold' call
    var accumulator = new (Cents())(Companion_instance.get_cents_3bbzqx_k$(0));
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      var sum = accumulator.inCents_1;
      accumulator = new (Cents())(Cents__plus_impl_qsv4s8(sum, element.amount_1));
    }
    var tmp$ret$8 = accumulator.inCents_1;
    return Cents__toString_impl_ko5hxm(tmp$ret$8);
  });
  var tmp_4 = remittanceSummary$lambda_4;
  keyValue(element, tmp_4, ($this$keyValue) => {
    var tmp0 = totals.grants_1.get_values_ksazhn_k$();
    // Inline function 'kotlin.collections.fold' call
    var accumulator = new (Cents())(Companion_instance.get_cents_3bbzqx_k$(0));
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      var sum = accumulator.inCents_1;
      accumulator = new (Cents())(Cents__plus_impl_qsv4s8(sum, element.amount_1));
    }
    var tmp$ret$10 = accumulator.inCents_1;
    return Cents__toString_impl_ko5hxm(tmp$ret$10);
  });
  var tmp_5 = remittanceSummary$lambda_5;
  keyValue(element, tmp_5, ($this$keyValue) => Cents__toString_impl_ko5hxm(totals.paidByFamily_1));
  var tmp_6 = get_bold(element);
  var tmp_7 = remittanceSummary$lambda_6;
  keyValue(tmp_6, tmp_7, ($this$keyValue) => Cents__toString_impl_ko5hxm(totals.get_totalContributions_2d9vkp_k$()));
  var tmp_8 = remittanceSummary$lambda_7;
  keyValue(element, tmp_8, ($this$keyValue) => {
    var tmp0 = payers;
    // Inline function 'kotlin.collections.fold' call
    var accumulator = new (Cents())(Companion_instance.get_cents_3bbzqx_k$(0));
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      var sum = accumulator.inCents_1;
      accumulator = new (Cents())(Cents__plus_impl_qsv4s8(sum, element.administrativeCharge_1));
    }
    var tmp$ret$12 = accumulator.inCents_1;
    return Cents__toString_impl_ko5hxm(tmp$ret$12);
  });
  element.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element);
  return element;
}
function remittanceChildTotals(_this__u8e3s4, grid, month) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(true);
  // Inline function 'kotlin.collections.map' call
  var this_0 = grid.placements_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var item = _iterator__ex2g4s.next_20eer_k$();
    var tmp$ret$6 = new (remittanceChildTotals$ChildRow())(item.placement_1, filterNotNull(item.perDate_1));
    destination.add_utx5q5_k$(tmp$ret$6);
  }
  var rows = destination;
  // Inline function 'kotlin.collections.fold' call
  var accumulator = new (BilledDayTotals())();
  var _iterator__ex2g4s_0 = rows.iterator_jk1svi_k$();
  while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
    var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
    accumulator = accumulator.plus_8jdhal_k$(element_0.totals_1);
  }
  var grand = accumulator;
  // Inline function 'com.lightningkite.kiteui.views.direct.h2' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (TextView())(element.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  element.willAddChild_hz2iwc_k$(element_1);
  element_1.set_themeChoice_py59um_k$(element_1.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H2Semantic())));
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
  element_1.invoke_bnq13k_k$(tmp_1, remittanceChildTotals$lambda);
  element_1.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (TextView())(element.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  element.willAddChild_hz2iwc_k$(element_2);
  element_2.set_themeChoice_py59um_k$(element_2.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
  var tmp_2 = KMutableProperty0();
  var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_2);
  var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_2));
  element_2.invoke_bnq13k_k$(tmp_4, remittanceChildTotals$lambda_0);
  element_2.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_2);
  var tmp_5 = _Constant___init__impl__v45mub(rows);
  var tmp_6 = ($this$tableWithSticky, child) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element = new (Button())($this$tableWithSticky.get_context_h02k06_k$());
    ensureOutermostElement(element);
    $this$tableWithSticky.willAddChild_hz2iwc_k$(element);
    element.set_action_2ds022_k$(Action("Child's month", VOID, VOID, VOID, VOID, VOID, remittanceChildTotals$lambda$slambda(element, child, month)));
    element.onStartup_vrxh3i_k$();
    $this$tableWithSticky.addChild_2qpft2_k$(element);
    return element;
  };
  var tmp_7 = get_rem(3);
  var tmp_8 = remittanceChildTotals$lambda_1;
  var tmp_9 = new (Fixed())(get_rem(12));
  var tmp_10 = remittanceChildTotals$lambda_2;
  var tmp_11 = _Constant___init__impl__v45mub(listOf(new (TableColumn())(tmp_8, tmp_9, VOID, tmp_10, VOID, remittanceChildTotals$lambda_3)));
  var tmp_12 = remittanceChildTotals$lambda_4;
  var tmp_13 = get_rem(5);
  var tmp_14 = listOf(remittanceChildTotals$column(grand, tmp_12, tmp_13, remittanceChildTotals$lambda_5));
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = get_entries();
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var _iterator__ex2g4s_1 = tmp0.iterator_jk1svi_k$();
  while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
    var element_3 = _iterator__ex2g4s_1.next_20eer_k$();
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_1 = grand.regularDays_1;
    if ((isInterface(this_1, KtMap()) ? this_1 : THROW_CCE()).containsKey_aw81wo_k$(element_3)) {
      destination_0.add_utx5q5_k$(element_3);
    }
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(destination_0, 10));
  var _iterator__ex2g4s_2 = destination_0.iterator_jk1svi_k$();
  while (_iterator__ex2g4s_2.hasNext_bitz1p_k$()) {
    var item_0 = _iterator__ex2g4s_2.next_20eer_k$();
    var tmp_15 = remittanceChildTotals$lambda_6(item_0);
    var tmp_16 = get_rem(5);
    var tmp$ret$29 = remittanceChildTotals$column(grand, tmp_15, tmp_16, remittanceChildTotals$lambda_7(item_0));
    destination_1.add_utx5q5_k$(tmp$ret$29);
  }
  var tmp_17 = plus_0(tmp_14, destination_1);
  // Inline function 'kotlin.collections.filter' call
  var tmp0_0 = get_entries();
  // Inline function 'kotlin.collections.filterTo' call
  var destination_2 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var _iterator__ex2g4s_3 = tmp0_0.iterator_jk1svi_k$();
  while (_iterator__ex2g4s_3.hasNext_bitz1p_k$()) {
    var element_4 = _iterator__ex2g4s_3.next_20eer_k$();
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_2 = grand.intermittentDays_1;
    if ((isInterface(this_2, KtMap()) ? this_2 : THROW_CCE()).containsKey_aw81wo_k$(element_4)) {
      destination_2.add_utx5q5_k$(element_4);
    }
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_3 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(destination_2, 10));
  var _iterator__ex2g4s_4 = destination_2.iterator_jk1svi_k$();
  while (_iterator__ex2g4s_4.hasNext_bitz1p_k$()) {
    var item_1 = _iterator__ex2g4s_4.next_20eer_k$();
    var tmp_18 = remittanceChildTotals$lambda_8(item_1);
    var tmp_19 = get_rem(10);
    var tmp$ret$37 = remittanceChildTotals$column(grand, tmp_18, tmp_19, remittanceChildTotals$lambda_9(item_1));
    destination_3.add_utx5q5_k$(tmp$ret$37);
  }
  var tmp_20 = plus_0(tmp_17, destination_3);
  var tmp_21 = remittanceChildTotals$lambda_10;
  var tmp_22 = get_rem(12);
  var tmp_23 = remittanceChildTotals$column(grand, tmp_21, tmp_22, remittanceChildTotals$lambda_11);
  var tmp_24 = remittanceChildTotals$lambda_12;
  var tmp_25 = get_rem(12);
  var tmp_26 = remittanceChildTotals$column(grand, tmp_24, tmp_25, remittanceChildTotals$lambda_13);
  var tmp_27 = remittanceChildTotals$lambda_14;
  var tmp_28 = get_rem(12);
  var tmp_29 = remittanceChildTotals$column(grand, tmp_27, tmp_28, remittanceChildTotals$lambda_15);
  var tmp_30 = remittanceChildTotals$lambda_16;
  var tmp_31 = get_rem(12);
  var tmp_32 = remittanceChildTotals$column(grand, tmp_30, tmp_31, remittanceChildTotals$lambda_17);
  var tmp_33 = remittanceChildTotals$lambda_18;
  var tmp_34 = get_rem(8);
  var tmp_35 = remittanceChildTotals$column(grand, tmp_33, tmp_34, remittanceChildTotals$lambda_19);
  var tmp_36 = remittanceChildTotals$lambda_20;
  var tmp_37 = get_rem(8);
  var tmp_38 = remittanceChildTotals$column(grand, tmp_36, tmp_37, remittanceChildTotals$lambda_21);
  var tmp_39 = remittanceChildTotals$lambda_22;
  var tmp_40 = get_rem(8);
  tableWithSticky(element, new (Constant())(tmp_5), tmp_6, tmp_7, new (Constant())(tmp_11), new (Constant())(_Constant___init__impl__v45mub(plus_0(tmp_20, listOf_0([tmp_23, tmp_26, tmp_29, tmp_32, tmp_35, tmp_38, remittanceChildTotals$column(grand, tmp_39, tmp_40, remittanceChildTotals$lambda_23)])))));
  element.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element);
  return element;
}
function childMonthDialog(_this__u8e3s4, placement, days, totals, month) {
  return dialog(_this__u8e3s4, VOID, ($this$dialog, close) => {
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = days;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity);
    var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      var tmp$ret$2 = element.forDate_1;
      destination.put_4fpzoq_k$(tmp$ret$2, element);
    }
    var byDate = destination;
    // Inline function 'kotlin.collections.List' call
    // Inline function 'kotlin.collections.MutableList' call
    var size = get_isoDayNumber(month.start_1.get_dayOfWeek_3kfgci_k$()) % 7 | 0;
    var list = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(size);
    // Inline function 'kotlin.repeat' call
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        list.add_utx5q5_k$(null);
      }
       while (inductionVariable < size);
    var cells = plus_0(list, toList(month));
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    var this_1 = get_scrolling(sizeConstraints($this$dialog, VOID, VOID, VOID, VOID, VOID, get_rem(56)));
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_0 = new (RowOrCol())(this_1.get_context_h02k06_k$());
    ensureOutermostElement(element_0);
    this_1.willAddChild_hz2iwc_k$(element_0);
    element_0.set_vertical_nuap32_k$(true);
    h2(element_0, placement.childName_1);
    // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_1 = new (TextView())(element_0.get_context_h02k06_k$());
    ensureOutermostElement(element_1);
    element_0.willAddChild_hz2iwc_k$(element_1);
    element_1.set_themeChoice_py59um_k$(element_1.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
    var tmp = KMutableProperty0();
    var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
    var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
    element_1.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
      var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$($this$invoke.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careLocations_f1rtw_k$().get_6ueaa7_k$(new (ID_0())(placement.location_1)));
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.name_1;
      return (tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs) + ' \xB7 ' + month.toString();
    });
    element_1.onStartup_vrxh3i_k$();
    element_0.addChild_2qpft2_k$(element_1);
    // Inline function 'com.lightningkite.kiteui.views.card' call
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    var this_2 = themed(element_0, CardSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_2 = new (RowOrCol())(this_2.get_context_h02k06_k$());
    ensureOutermostElement(element_2);
    this_2.willAddChild_hz2iwc_k$(element_2);
    element_2.set_vertical_nuap32_k$(true);
    var tmp_2 = childMonthDialog$lambda$lambda;
    keyValue(element_2, tmp_2, ($this$keyValue) => totals.days_1.toString());
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_0 = totals.regularDays_1.get_entries_p20ztl_k$().iterator_jk1svi_k$();
    while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
      var _destruct__k2r9zo = _iterator__ex2g4s_0.next_20eer_k$();
      // Inline function 'kotlin.collections.component1' call
      var time = _destruct__k2r9zo.get_key_18j28a_k$();
      // Inline function 'kotlin.collections.component2' call
      var count = _destruct__k2r9zo.get_value_j01efc_k$();
      var tmp_3 = childMonthDialog$lambda$lambda_0(time);
      keyValue(element_2, tmp_3, childMonthDialog$lambda$lambda_1(count));
    }
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_1 = totals.intermittentDays_1.get_entries_p20ztl_k$().iterator_jk1svi_k$();
    while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
      var _destruct__k2r9zo_0 = _iterator__ex2g4s_1.next_20eer_k$();
      // Inline function 'kotlin.collections.component1' call
      var time_0 = _destruct__k2r9zo_0.get_key_18j28a_k$();
      // Inline function 'kotlin.collections.component2' call
      var count_0 = _destruct__k2r9zo_0.get_value_j01efc_k$();
      var tmp_4 = childMonthDialog$lambda$lambda_2(time_0);
      keyValue(element_2, tmp_4, childMonthDialog$lambda$lambda_3(count_0));
    }
    var tmp_5 = childMonthDialog$lambda$lambda_4;
    keyValue(element_2, tmp_5, ($this$keyValue) => totals.transportOneWay_1.toString());
    var tmp_6 = childMonthDialog$lambda$lambda_5;
    keyValue(element_2, tmp_6, ($this$keyValue) => totals.transportTwoWay_1.toString());
    var tmp_7 = childMonthDialog$lambda$lambda_6;
    keyValue(element_2, tmp_7, ($this$keyValue) => $this$keyValue.invoke_r7m7el_k$(get_strings(AppState_getInstance())).remittanceAbsencesValue_hrzn9f_k$(totals.explainedAbsences_1, totals.unexplainedAbsences_1));
    var tmp_8 = childMonthDialog$lambda$lambda_7;
    keyValue(element_2, tmp_8, ($this$keyValue) => Cents__toString_impl_ko5hxm(totals.price_1));
    var tmp_9 = childMonthDialog$lambda$lambda_8;
    keyValue(element_2, tmp_9, ($this$keyValue) => Cents__toString_impl_ko5hxm(totals.paidByFamily_1));
    var tmp_10 = get_bold(element_2);
    var tmp_11 = childMonthDialog$lambda$lambda_9;
    keyValue(tmp_10, tmp_11, ($this$keyValue) => Cents__toString_impl_ko5hxm(totals.get_totalContributions_2d9vkp_k$()));
    element_2.onStartup_vrxh3i_k$();
    this_2.addChild_2qpft2_k$(element_2);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_3 = new (RowOrCol())(element_0.get_context_h02k06_k$());
    ensureOutermostElement(element_3);
    element_0.willAddChild_hz2iwc_k$(element_3);
    element_3.set_vertical_nuap32_k$(false);
    var _iterator__ex2g4s_2 = listOf_0(['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']).iterator_jk1svi_k$();
    while (_iterator__ex2g4s_2.hasNext_bitz1p_k$()) {
      var weekday = _iterator__ex2g4s_2.next_20eer_k$();
      // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      var this_3 = sizeConstraints(element_3, VOID, VOID, VOID, VOID, VOID, get_rem_0(6.5));
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_4 = new (TextView())(this_3.get_context_h02k06_k$());
      ensureOutermostElement(element_4);
      this_3.willAddChild_hz2iwc_k$(element_4);
      element_4.set_themeChoice_py59um_k$(element_4.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
      // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
      var tmp_12 = element_4.native_1;
      var tmp_13;
      // Inline function 'kotlin.text.isEmpty' call
      if (charSequenceLength(weekday) === 0) {
        tmp_13 = '\xA0';
      } else {
        tmp_13 = weekday;
      }
      tmp_12.set_content_i5lrjv_k$(tmp_13);
      element_4.set_align_ypalx0_k$(Align_Center_getInstance());
      element_4.onStartup_vrxh3i_k$();
      this_3.addChild_2qpft2_k$(element_4);
    }
    element_3.onStartup_vrxh3i_k$();
    element_0.addChild_2qpft2_k$(element_3);
    var _iterator__ex2g4s_3 = chunked(cells, 7).iterator_jk1svi_k$();
    while (_iterator__ex2g4s_3.hasNext_bitz1p_k$()) {
      var week = _iterator__ex2g4s_3.next_20eer_k$();
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_5 = new (RowOrCol())(element_0.get_context_h02k06_k$());
      ensureOutermostElement(element_5);
      element_0.willAddChild_hz2iwc_k$(element_5);
      element_5.set_vertical_nuap32_k$(false);
      // Inline function 'kotlin.collections.List' call
      // Inline function 'kotlin.collections.MutableList' call
      var size_0 = 7 - week.get_size_woubt6_k$() | 0;
      var list_0 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(size_0);
      // Inline function 'kotlin.repeat' call
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < size_0)
        do {
          var index_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          list_0.add_utx5q5_k$(null);
        }
         while (inductionVariable_0 < size_0);
      var _iterator__ex2g4s_4 = plus_0(week, list_0).iterator_jk1svi_k$();
      while (_iterator__ex2g4s_4.hasNext_bitz1p_k$()) {
        var date = _iterator__ex2g4s_4.next_20eer_k$();
        if (date == null) {
          // Inline function 'com.lightningkite.kiteui.views.direct.space' call
          var this_4 = sizeConstraints(element_5, VOID, VOID, VOID, VOID, VOID, get_rem_0(6.5));
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_6 = new (Space())(this_4.get_context_h02k06_k$());
          ensureOutermostElement(element_6);
          this_4.willAddChild_hz2iwc_k$(element_6);
          element_6.onStartup_vrxh3i_k$();
          this_4.addChild_2qpft2_k$(element_6);
        } else {
          // Inline function 'com.lightningkite.kiteui.views.card' call
          var this_5 = sizeConstraints(element_5, VOID, VOID, VOID, VOID, VOID, get_rem_0(6.5));
          // Inline function 'com.lightningkite.kiteui.views.compact' call
          var this_6 = themed(this_5, CardSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          var this_7 = themed(this_6, CompactSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_7 = new (RowOrCol())(this_7.get_context_h02k06_k$());
          ensureOutermostElement(element_7);
          this_7.willAddChild_hz2iwc_k$(element_7);
          element_7.set_vertical_nuap32_k$(true);
          subtext(element_7, date.day_1.toString());
          var day = byDate.get_wei43m_k$(date);
          if (!(day == null)) {
            // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
            var this_8 = themed(element_7, new (AttendanceEntryBox())(Companion_instance_0.of_fosl41_k$(day.attendance_1.case_1)));
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_8 = new (Frame())(this_8.get_context_h02k06_k$());
            ensureOutermostElement(element_8);
            this_8.willAddChild_hz2iwc_k$(element_8);
            text(get_centered(element_8), day.attendance_1.get_massachusettsAttendanceCode_3eo4hh_k$().get_code_wok7xy_k$());
            element_8.onStartup_vrxh3i_k$();
            this_8.addChild_2qpft2_k$(element_8);
            subtext(element_7, day.attendance_1.get_billedTime_8fk3ac_k$().code_1 + ' \xB7 ' + Cents__toString_impl_ko5hxm(day.price_1));
          }
          element_7.onStartup_vrxh3i_k$();
          this_7.addChild_2qpft2_k$(element_7);
        }
      }
      element_5.onStartup_vrxh3i_k$();
      element_0.addChild_2qpft2_k$(element_5);
    }
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_9 = new (RowOrCol())(element_0.get_context_h02k06_k$());
    ensureOutermostElement(element_9);
    element_0.willAddChild_hz2iwc_k$(element_9);
    element_9.set_vertical_nuap32_k$(false);
    // Inline function 'com.lightningkite.kiteui.views.expanding' call
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    var this_9 = weight(element_9, 1.0);
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_10 = new (Space())(this_9.get_context_h02k06_k$());
    ensureOutermostElement(element_10);
    this_9.willAddChild_hz2iwc_k$(element_10);
    element_10.onStartup_vrxh3i_k$();
    this_9.addChild_2qpft2_k$(element_10);
    // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    var this_10 = themed(element_9, ButtonSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_11 = new (Button())(this_10.get_context_h02k06_k$());
    ensureOutermostElement(element_11);
    this_10.willAddChild_hz2iwc_k$(element_11);
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_12 = new (TextView())(element_11.get_context_h02k06_k$());
    ensureOutermostElement(element_12);
    element_11.willAddChild_hz2iwc_k$(element_12);
    var tmp_14 = KMutableProperty0();
    var tmp_15 = TextView$_get_content_$ref_4pzcwl(element_12);
    var tmp_16 = getPropertyCallableRef('content', 0, tmp_14, tmp_15, TextView$_set_content_$ref_pketfb(element_12));
    element_12.invoke_bnq13k_k$(tmp_16, childMonthDialog$lambda$lambda_10);
    element_12.onStartup_vrxh3i_k$();
    element_11.addChild_2qpft2_k$(element_12);
    onClick(element_11, VOID, VOID, VOID, childMonthDialog$lambda$slambda(close, element_11, placement));
    element_11.onStartup_vrxh3i_k$();
    this_10.addChild_2qpft2_k$(element_11);
    element_9.onStartup_vrxh3i_k$();
    element_0.addChild_2qpft2_k$(element_9);
    element_0.onStartup_vrxh3i_k$();
    this_1.addChild_2qpft2_k$(element_0);
    return Unit_instance;
  });
}
function remittanceSummary$lambda($this$keyValue) {
  return $this$keyValue.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_remittanceChildrenLabel_g31cj6_k$();
}
function remittanceSummary$lambda_0($this$keyValue) {
  return $this$keyValue.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_remittanceDaysBilledLabel_iaro0g_k$();
}
function remittanceSummary$lambda_1($this$keyValue) {
  return $this$keyValue.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_remittanceAbsencesLabel_s31xd5_k$();
}
function remittanceSummary$lambda_2($this$keyValue) {
  return $this$keyValue.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_remittanceCostOfCareLabel_pxj9qw_k$();
}
function remittanceSummary$lambda_3($this$keyValue) {
  return $this$keyValue.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_remittanceEmployerSharesLabel_p173b2_k$();
}
function remittanceSummary$lambda_4($this$keyValue) {
  return $this$keyValue.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_remittanceGrantSharesLabel_3d2smj_k$();
}
function remittanceSummary$lambda_5($this$keyValue) {
  return $this$keyValue.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_remittanceFamilyPaysLabel_f1jlxa_k$();
}
function remittanceSummary$lambda_6($this$keyValue) {
  return $this$keyValue.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_remittanceTcgPaysLabel_z6hcxk_k$();
}
function remittanceSummary$lambda_7($this$keyValue) {
  return $this$keyValue.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_remittanceAdministrationLabel_spr4f_k$();
}
var remittanceChildTotals$ChildRowClass;
function remittanceChildTotals$ChildRow() {
  if (remittanceChildTotals$ChildRowClass === VOID) {
    class $ {
      constructor(placement, days) {
        this.placement_1 = placement;
        this.days_1 = days;
        this.totals_1 = Companion_getInstance().of_tann9x_k$(this.days_1);
      }
    }
    initMetadataForClass($, 'ChildRow');
    remittanceChildTotals$ChildRowClass = $;
  }
  return remittanceChildTotals$ChildRowClass;
}
function remittanceChildTotals$column(grand, name, width, of) {
  var tmp = new (Fixed())(width);
  var tmp_0 = ($this$TableColumn) => toString(of(grand));
  return new (TableColumn())(name, tmp, VOID, tmp_0, VOID, ($this$TableColumn, row) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element = new (TextView())($this$TableColumn.get_context_h02k06_k$());
    ensureOutermostElement(element);
    $this$TableColumn.willAddChild_hz2iwc_k$(element);
    var tmp = KMutableProperty0();
    var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
    var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
    element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => toString(of($this$invoke.invoke_r7m7el_k$(row).totals_1)));
    element.onStartup_vrxh3i_k$();
    $this$TableColumn.addChild_2qpft2_k$(element);
    return Unit_instance;
  });
}
function remittanceChildTotals$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_remittanceChildTotalsHeading_ish2aq_k$();
}
function remittanceChildTotals$lambda_0($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_remittanceChildTotalsHint_sqdm97_k$();
}
function remittanceChildTotals$lambda$slambda($$this$button, $child, $month) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    var tmp = $$this$button.get_context_h02k06_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $child;
    var tmp_0 = (yield* await_0(this_0, $completion)).placement_1;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = $child;
    var tmp_1 = (yield* await_0(this_1, $completion)).days_1;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = $child;
    var tmp$ret$2 = yield* await_0(this_2, $completion);
    childMonthDialog(tmp, tmp_0, tmp_1, tmp$ret$2.totals_1, $month);
    return Unit_instance;
  }), 1);
}
function remittanceChildTotals$lambda_1($this$TableColumn) {
  return $this$TableColumn.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_remittanceChildColumn_w7inzf_k$();
}
function remittanceChildTotals$lambda_2($this$TableColumn) {
  return $this$TableColumn.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_remittanceGrandTotal_q37hep_k$();
}
function remittanceChildTotals$lambda_3($this$TableColumn, row) {
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (TextView())($this$TableColumn.get_context_h02k06_k$());
  ensureOutermostElement(element);
  $this$TableColumn.willAddChild_hz2iwc_k$(element);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
  element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(row).placement_1.childName_1);
  element.onStartup_vrxh3i_k$();
  $this$TableColumn.addChild_2qpft2_k$(element);
  return Unit_instance;
}
function remittanceChildTotals$lambda_4($this$column) {
  return $this$column.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_remittanceDaysColumn_y81ogk_k$();
}
function remittanceChildTotals$lambda_5(it) {
  return it.days_1;
}
function remittanceChildTotals$lambda_6($time) {
  return ($this$column) => $time.code_1;
}
function remittanceChildTotals$lambda_7($time) {
  return (it) => {
    var tmp0_elvis_lhs = it.regularDays_1.get_wei43m_k$($time);
    return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  };
}
function remittanceChildTotals$lambda_8($time) {
  return ($this$column) => $this$column.invoke_r7m7el_k$(get_strings(AppState_getInstance())).remittanceIntermittentColumn_diw8ct_k$($time.code_1);
}
function remittanceChildTotals$lambda_9($time) {
  return (it) => {
    var tmp0_elvis_lhs = it.intermittentDays_1.get_wei43m_k$($time);
    return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  };
}
function remittanceChildTotals$lambda_10($this$column) {
  return $this$column.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_remittanceTransportOneWayColumn_7s8g1t_k$();
}
function remittanceChildTotals$lambda_11(it) {
  return it.transportOneWay_1;
}
function remittanceChildTotals$lambda_12($this$column) {
  return $this$column.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_remittanceTransportTwoWayColumn_2m8bh7_k$();
}
function remittanceChildTotals$lambda_13(it) {
  return it.transportTwoWay_1;
}
function remittanceChildTotals$lambda_14($this$column) {
  return $this$column.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_remittanceExplainedAbsencesColumn_949z39_k$();
}
function remittanceChildTotals$lambda_15(it) {
  return it.explainedAbsences_1;
}
function remittanceChildTotals$lambda_16($this$column) {
  return $this$column.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_remittanceUnexplainedAbsencesColumn_7oks0u_k$();
}
function remittanceChildTotals$lambda_17(it) {
  return it.unexplainedAbsences_1;
}
function remittanceChildTotals$lambda_18($this$column) {
  return $this$column.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_remittanceCostOfCareLabel_pxj9qw_k$();
}
function remittanceChildTotals$lambda_19(it) {
  return new (Cents())(it.price_1);
}
function remittanceChildTotals$lambda_20($this$column) {
  return $this$column.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_remittanceFamilyPaysColumn_yxf9kk_k$();
}
function remittanceChildTotals$lambda_21(it) {
  return new (Cents())(it.paidByFamily_1);
}
function remittanceChildTotals$lambda_22($this$column) {
  return $this$column.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_remittanceTcgPaysColumn_l2qjv6_k$();
}
function remittanceChildTotals$lambda_23(it) {
  return new (Cents())(it.get_totalContributions_2d9vkp_k$());
}
function childMonthDialog$lambda$lambda($this$keyValue) {
  return $this$keyValue.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_remittanceDaysBilledLabel_iaro0g_k$();
}
function childMonthDialog$lambda$lambda_0($time) {
  return ($this$keyValue) => $time.displayName_1;
}
function childMonthDialog$lambda$lambda_1($count) {
  return ($this$keyValue) => $count.toString();
}
function childMonthDialog$lambda$lambda_2($time) {
  return ($this$keyValue) => $this$keyValue.invoke_r7m7el_k$(get_strings(AppState_getInstance())).remittanceIntermittentColumn_diw8ct_k$($time.displayName_1);
}
function childMonthDialog$lambda$lambda_3($count) {
  return ($this$keyValue) => $count.toString();
}
function childMonthDialog$lambda$lambda_4($this$keyValue) {
  return $this$keyValue.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_remittanceTransportOneWayColumn_7s8g1t_k$();
}
function childMonthDialog$lambda$lambda_5($this$keyValue) {
  return $this$keyValue.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_remittanceTransportTwoWayColumn_2m8bh7_k$();
}
function childMonthDialog$lambda$lambda_6($this$keyValue) {
  return $this$keyValue.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_remittanceAbsencesLabel_s31xd5_k$();
}
function childMonthDialog$lambda$lambda_7($this$keyValue) {
  return $this$keyValue.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_remittanceCostOfCareLabel_pxj9qw_k$();
}
function childMonthDialog$lambda$lambda_8($this$keyValue) {
  return $this$keyValue.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_remittanceFamilyPaysLabel_f1jlxa_k$();
}
function childMonthDialog$lambda$lambda_9($this$keyValue) {
  return $this$keyValue.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_remittanceTcgPaysLabel_z6hcxk_k$();
}
function childMonthDialog$lambda$lambda_10($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_remittanceOpenPlacementButton_cb7i92_k$();
}
function childMonthDialog$lambda$slambda($close, $$this$button, $placement) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    $close();
    get_pageNavigator($$this$button.get_context_h02k06_k$()).navigate_sm5lxf_k$(new (ChildPlacementDetailPage())($placement._id_1));
    return Unit_instance;
  }), 0);
}
//region block: exports
export {
  monthStarting as monthStarting2k0geg6vqg7e9,
  get_range as get_range1w8h4wo8ecr88,
  remittanceChildTotals as remittanceChildTotals1vleuy0834qvm,
  remittanceSummary as remittanceSummary7eycmz4clrlq,
};
//endregion

//# sourceMappingURL=remittanceComponents.mjs.map
